<template>
  <div>
    <UserInput
      v-if="activeUserInteraction && activeUserInteractionInputType == 'text'"
      :onSubmit="onUserInputSubmit"
      @onType="$emit('onType')"
      :chatbotColors="chatbotColors" />

    <UserInputCurrencyReal
      v-if="activeUserInteraction && activeUserInteractionInputType == 'valor_moeda_real'"
      :onSubmit="onUserInputSubmit"
      @onType="$emit('onType')"
      :chatbotColors="chatbotColors" />
  </div>
</template>

<script>
import UserInput from './inputs/UserInput.vue'
import UserInputCurrencyReal from './inputs/UserInputCurrencyReal.vue'

export default {
  components: {
    UserInput,
    UserInputCurrencyReal
  },
  props: {
    onUserInputSubmit: {
      type: Function,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeUserInteraction () {
      return this.$store.state.activeUserInteraction;
    },
    activeUserInteractionInputType () {
      return this.$store.state.activeUserInteractionInputType;
    }
  },
}
</script>
